import { createApp } from 'vue/dist/vue.esm-bundler';
import { defineAsyncComponent } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import SiteIcon from '@app/components/SiteIcon.vue';
import SiteLink from '@app/components/SiteLink.vue';
import '@app/plugins/validation.ts';
import { configure } from 'vee-validate';
import language from '@app/utils/language/languageClient';
import { defineValidationRules } from '@app/plugins/validation';
import 'virtual:svg-icons-register';

configure({
  validateOnBlur: false,
  validateOnChange: false,
  validateOnInput: false,
  validateOnModelUpdate: false
});

if (document.getElementById('app')) {
  const pinia = createPinia();
  pinia.use(piniaPluginPersistedstate);

  const app = createApp({
    components: {
      // Components
      'site-header': defineAsyncComponent(() => import('@app/components/SiteHeader.vue')),
      'site-footer': defineAsyncComponent(() => import('@app/components/SiteFooter.vue')),
      'site-initializer': defineAsyncComponent(() => import('@app/components/SiteInitializer.vue')),
      'skip-link': defineAsyncComponent(() => import('@app/components/SkipLink.vue')),
      // Pages
      'home-page': defineAsyncComponent(() => import('@app/pages/home/HomePage.vue')),
      'privacy-policy-page': defineAsyncComponent(
        () => import('@app/pages/privacy-policy/PrivacyPolicy.vue')
      ),
      'terms-of-use-page': defineAsyncComponent(
        () => import('@app/pages/terms-of-use/TermsOfUse.vue')
      ),
      'about-us-page': defineAsyncComponent(() => import('@app/pages/about-us/AboutUs.vue')),
      'my-resources-page': defineAsyncComponent(
        () => import('@app/pages/my-resources/MyResourcesPage.vue')
      ),
      'tech-support-page': defineAsyncComponent(
        () => import('@app/pages/tech-support/TechSupport.vue')
      ),
      'my-account-page': defineAsyncComponent(() => import('@app/pages/my-account/MyAccount.vue')),
      'hub-page': defineAsyncComponent(() => import('@app/pages/hub-page/HubPage.vue')),
      'job-search-page': defineAsyncComponent(
        () => import('@app/pages/job-search/JobSearchPage.vue')
      ),
      'superhub-page': defineAsyncComponent(
        () => import('@app/pages/superhub-page/SuperhubPage.vue')
      ),
      'scholarship-page': defineAsyncComponent(
        () => import('@app/pages/scholarship/ScholarshipPage.vue')
      ),
      'school-page': defineAsyncComponent(() => import('@app/pages/school/SchoolPage.vue')),
      'online-school-page': defineAsyncComponent(
        () => import('@app/pages/school/OnlineSchoolPage.vue')
      ),
      'graduate-school-page': defineAsyncComponent(
        () => import('@app/pages/school/GraduateSchoolPage.vue')
      ),
      'wizard-page': defineAsyncComponent(() => import('@app/pages/wizard-page/WizardPage.vue')),
      'undergrad-page': defineAsyncComponent(
        () => import('@app/pages/school/UndergradSchoolPage.vue')
      ),
      'reset-password-page': defineAsyncComponent(
        () => import('@app/pages/reset-password/ResetPasswordPage.vue')
      ),
      'login-page': defineAsyncComponent(() => import('@app/pages/login-page/LoginPage.vue')),
      'register-page': defineAsyncComponent(
        () => import('@app/pages/register-page/RegisterPage.vue')
      ),
      'title-list-page': defineAsyncComponent(
        () => import('@app/pages/title-list/TitleListPage.vue')
      ),
      'index-page': defineAsyncComponent(() => import('@app/pages/index/IndexPage.vue')),
      'search-page': defineAsyncComponent(() => import('@app/pages/search/SearchPage.vue')),
      'search-school-page': defineAsyncComponent(
        () => import('@app/pages/school-search/SchoolSearch.vue')
      ),
      'search-scholarship-page': defineAsyncComponent(
        () => import('@app/pages/scholarship-search/ScholarshipSearchPage.vue')
      ),
      'pathway-u-page': defineAsyncComponent(() => import('@app/pages/pathway-u/PathwayUPage.vue')),
      'milady-cima-page': defineAsyncComponent(
        () => import('@app/pages/milady-cima/MiladyCima.vue')
      ),
      // Error pages
      'error-400-page': defineAsyncComponent(() => import('@app/pages/400-page/400Page.vue')),
      'error-401-page': defineAsyncComponent(() => import('@app/pages/401-page/401Page.vue')),
      'error-404-page': defineAsyncComponent(() => import('@app/pages/404-page/404Page.vue')),
      'error-419-page': defineAsyncComponent(() => import('@app/pages/419-page/419Page.vue'))
    }
  });

  //TODO: not binding, needs fix
  app.directive('is-loading', {
    beforeMount(el, binding) {
      el.classList.toggle('is-loading', binding.value);
    },
    update(el, binding) {
      el.classList.toggle('is-loading', binding.value);
    }
  });

  app.use(pinia);
  app.use(language);

  defineValidationRules(language.global.t);

  app.component('SiteIcon', SiteIcon);
  app.component('SiteLink', SiteLink);
  app.mount('#app');
} else {
  console.warn('Vue is not initialized, check the Blade template!');
}
